// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { JobListingsPage } from './pages/JobListingsPage';
import About from './pages/About'; // About

import NotFound from './pages/404'; // Import the NotFound component


const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<JobListingsPage />} />
        <Route path="/about" element={<About />} /> {/* About */}
        {/* The catch-all route must be the last one */}
        <Route path="*" element={<NotFound />} />

      </Routes>
    </Router>
  );
};

export default App;